// System dependencies

import Link from 'next/link';
import React from 'react';

// Application dependencies

import { RouteFields, RouteNames } from '@/interfaces/route.interfaces';
import { manageFormSpinner } from '@/lib/functions';

// Props

interface NavlinkProps {
  displaySpinner?: boolean;
  href?: string;
  label: string;
  onClick?: () => void;
}

const Navlink: React.FC<NavlinkProps> = ({ displaySpinner = true, href = RouteNames[RouteFields.Placeholder].route, label, onClick }) => {
  // ---------------------------------------------------------------------------------------------------------------------------------------
  // Form interaction and rendering
  // ---------------------------------------------------------------------------------------------------------------------------------------

  return (
    <div onClick={() => displaySpinner && manageFormSpinner(`loading ${label} page - please wait`)}>
      <Link className="text-md cursor-pointer whitespace-nowrap font-semibold text-primary hover:text-logoblue dark:hover:text-logoblue-300" href={href} {...(onClick ? { onClick } : {})}>
        {label}
      </Link>
    </div>
  );
};

export default Navlink;
